module.exports = __webpack_public_path__ + "images/exterior-3d-2-4d058ff7e4c0f963ad6d8aede85390c4.jpg";